import './modal.less';
import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';
import cn from 'classname';
import isFunction from 'lodash/isFunction';

const ModalBox = props => {
	return (
		<Modal
			className={cn({
				[props.className]: true,
				'modal-overlay__content': !props.className
			})}
			overlayClassName="modal-overlay"
			isOpen={props.isOpen}
			onRequestClose={props.onClose}
			contentLabel="Modal"
		>
			<div className="modal-wrap">
				<h3 className="font-proxima-nova-bold">{props.title}</h3>
				{ isFunction(props.onClose) && (
					<a
						href="#"
						className="modal-close"
						onClick={e => {
							e.preventDefault();
							props.onClose();
						}}
					/>
				) }
				{props.body}
			</div>
		</Modal>
	);
};

ModalBox.propTypes = {
	className: PropTypes.string,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	title: PropTypes.string,
	body: PropTypes.node
};

export default ModalBox;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/modal.js